import React from 'react';
import pageNotFound from '../helpers/lottie-files/pageNotFound.json';
import LottieAnimation from '../components/LottieAnimation';

export default function PageNotFound(props) {
    return (
        <div className="w-full">
            <div className="h-full px-8">
                <div className="text-center flex flex-col justify-center items-center h-screen">
                    <LottieAnimation loop={false} animateFile={pageNotFound} width={250} height={250} />
                    <p className='font-medium text-[18px]'>Page Not Found</p>
                </div>
            </div>
        </div>
    );
}